module.exports = __webpack_public_path__ + "static/media/logo-flag.4631c9db.svg";